import React from 'react';
import { FormControlLabel, Switch } from '@mui/material';
interface ToggleWithLabelProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}
const ToggleWithLabel: React.FC<ToggleWithLabelProps> = ({ label, checked = true, onChange }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <FormControlLabel control={<Switch checked={checked} onChange={e => onChange(e.target.checked)} />} label={label} />
    </div>
  );
};
export default ToggleWithLabel;
